// extracted by mini-css-extract-plugin
export default {"root":"PublicHeader_root__77EQM","title":"PublicHeader_title__mDFJ6","subTitle":"PublicHeader_subTitle__Zy8i7"};